const checkoutForm = document.querySelector('[data-checkout]');

checkoutForm && (() => {
  let indexGroup = 0;
  const groups = checkoutForm.querySelectorAll('div[data-group]');
  const buttons = checkoutForm.querySelectorAll('button[data-group]');
  const nextButton = checkoutForm.querySelector('[data-next]');
  const fields = checkoutForm.querySelectorAll('[name]');

// do not submit checkout on enter hit
  checkoutForm.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });

// remove .is-error class on input change
  fields.forEach((field) => {
    field.addEventListener('input', (e) => {
      field.classList.remove('is-error');
    });
  });

  const switchGroup = (d) => {
    indexGroup += d;
    groups.forEach(
      (group, i) => group.classList.toggle('is-active', i === indexGroup));
    buttons.forEach(
      (group, i) => group.classList.toggle('is-active', i === indexGroup));
  };

// can go back only if there is a previous group
  buttons.forEach((button, i) => {
    button.addEventListener('click', (e) => {
      if (i < indexGroup) {
        switchGroup(-1);
      }
    });
  });

  nextButton.addEventListener('click', (e) => {
    let groupFields = groups[indexGroup].querySelectorAll(
      '.validate-required [name]');

    const shipToDifferentAddress = groups[indexGroup].querySelector(
      '[name="ship_to_different_address"]');
    // if shipping to different address is not checked, remove all shipping fields
    if (!shipToDifferentAddress || !shipToDifferentAddress.checked) {
      groupFields = [...groupFields].filter((field) => {
        return field.name.indexOf('shipping_') !== 0;
      });
    }

    // check if all required fields are filled
    const allFilled = [...groupFields].every((field) => {
      return field.value !== '';
    });

    if (!allFilled) {
      let isFocused = false;
      groupFields.forEach((field) => {
        if (field.value === '') {
          field.classList.add('is-error');

          if (!isFocused) {
            field.focus();
            isFocused = true;
          }
        }
      });

    } else {
      switchGroup(1);
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  });
})();

